export default __webpack_public_path__ + "static/media/dealermethodstablet.png.webp";